var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box p-3 box-min"},[_c('pie-chart',{attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}),_c('p',[_vm._v(" "+_vm._s(_vm.numberOfViews)+" Impressões ")]),_c('span',[_vm._v("Total de pessoas que visualizaram")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }